import BaseError from "../../error";

export class CsrfCookieRequestError extends BaseError {
	readonly name = "CsrfCookieRequestError";
	constructor(cause: Error) {
		super("CsrfCookie request failed.", cause);
	}
}

export class InvalidCredentialsError extends BaseError {
	readonly name = "InvalidCredentialsError";
	constructor(cause: Error) {
		super("The provided credentials where invalid.", cause);
	}
}

export class AuthenticationFailError extends BaseError {
	readonly name = "AuthenticationFailError";
	constructor(cause: Error | null = null) {
		super("The authentication failed.", cause);
	}
}
